import React from "react";
import ReactPlayer from "react-player";

const isLoomLink = (url) => {
  return url.includes("loom.com/share/") || url.includes("loom.com/embed/");
};

const convertLoomToEmbed = (url) => {
  if (url.includes("loom.com/share/")) {
    const id = url.split("/share/")[1]?.split("?")[0];
    return `https://www.loom.com/embed/${id}`;
  }
  return url;
};

const VideoPlayer = ({
  url,
  title = "Video",
  divHeight = "",
  divStyle = {},
  setUpdateState = () => {},
}) => {
  if (!url) return <p>No video URL provided</p>;

  const isLoom = isLoomLink(url);
  const finalUrl = isLoom ? convertLoomToEmbed(url) : url;

  if (isLoom) {
    return (
      <div
        className={`aspect-video w-full rounded-xl overflow-hidden`}
        style={{ height: divHeight, ...divStyle }}
      >
        <iframe
          src={finalUrl}
          frameBorder="0"
          allowFullScreen
          allow="autoplay; clipboard-write"
          title={title}
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    );
  }

  return (
    <div
      className={`aspect-video w-full rounded-xl overflow-hidden`}
      style={{ height: divHeight }}
    >
      <ReactPlayer
        url={finalUrl}
        controls
        width="100%"
        height="100%"
        style={divStyle}
        onDuration={(duration) => {
          console.log("Video Duration (in seconds):", duration);
          setUpdateState((prev) => ({
            ...prev,
            lessonMedia: {
              ...prev.lessonMedia,
              duration: duration,
            },
            totalDuration: duration,
          }));
        }}
        config={{
          file: {
            attributes: {
              controlsList: "nodownload",
              onContextMenu: (e) => e.preventDefault(),
            },
          },
        }}
      />
    </div>
  );
};

export default VideoPlayer;
